import React, { FunctionComponent, ReactNode } from "react"; 
import { FiInfo } from "react-icons/fi";
import IconButtonComponent from "../../IconButton";
import { Popover } from "@mui/material";


const InfoPopOver: FunctionComponent<{children: ReactNode}> = ({children}) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  
  return (
    <div style={{position: "fixed", left: "10px", bottom: "70px"}}>
      <IconButtonComponent icon={FiInfo} onClick={handleClick} />
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{vertical: "top", horizontal:"right" }}
      >
        {children}
      </Popover>
    </div>
  );
};

export default InfoPopOver;